for (const [key, value] of Object.entries(
	document.querySelectorAll(".img-on-bg")
)) {
	var col = value.closest(".wpb_column");
	if (col.classList.contains("col-12")) {
		col.before(value);
	} else if (col.classList.contains("col-6")) {
		console.log(col);
		col.before(value);
		value.style.width = "50%";
		if (value.previousElementSibling) {
			value.style.right = 0;
			value.style.left = "auto";
		} else {
			value.style.left = 0;
		}
	}
}

// seo

var articles_type_link = document.querySelectorAll(".article-type-link");
if (articles_type_link.length > 0) {
    articles_type_link.forEach((article) => {
        if (article.dataset.seoLink) {
            article.addEventListener('click', (e) => {
                article.querySelector('a').click();
            })
        }
    });
}
